<template>
<div>

<!-- Button trigger modal -->
<button  type="button" class="btn btn-outline-info ml-2" title="Mostra tabella misura" data-toggle="modal" data-target="#exampleModal">
  <i style="color:brown" class="fas fa-ruler-combined mr-2" aria-hidden="true"></i>
  TABELLA MISURE 
</button>

<!-- Modal -->
<div class="modal" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border border-info">
      <div class="modal-body">
        
        <div class="card border-info">
        <div class="card-header bg-info border-info text-white">

         <div class="row">
            <h4>
              
              <strong>
        
              TABELLA MISURE   </strong>
           </h4> 
           
        </div>
        
  </div>
  <button class="btn btn-success btn-sm  mt-3 ml-3 mr-3"  @click="setData()">MOSTRA {{ setBtnMsg }}</button>  
  <div class="card-body  card-body-scroll card-body-narrow mt-1"> 
   <div v-if="!spinner" class="table-responsive">
   <table class="table table-sm table-hover table-striped" id="table">
    <tbody>
      <tr  @click="provide(col)"   v-bind:style="{ backgroundColor : col.selected == true ? '#9ACD32' : ''   }"   v-for="(col,index) in filteredSizes" :key="index">
        <td class="text-center">                   
            {{col.size}}                
        </td>
      </tr>
    </tbody>
  </table>
      
</div>
<div v-else>
  <div class="spinner-grow spinner-grow-sm text-warning"   role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>  
<!-- BODY CARD -->
</div>

</div>

<small  id="sizeHelp" class="form-text text-muted"><strong>Selezionare/deselezionare una misura dall'elenco.</strong></small>    

<strong>FILTRA MISURA</strong> 
<input id="cerca" class="form-control" type="text" name="query" v-model="filterKey">

      </div>
      <div class="modal-footer">
        <button  type="button" class="btn btn-primary" data-dismiss="modal">CHIUDI</button>
      </div>
    </div>
  </div>
</div>


</div>
</template>

<script>

import api from '@/api'

import { mapGetters }   from 'vuex';
  export default {
    props:['selection'],
    
    data () {
      return {
        
        cols         : [],
        filterKey    : '',
        spinner      : false, 
        type         : true
       

        
      }
    },
  
     computed: 
  {
    ...mapGetters(['company']) , 
     setBtnMsg() {
          return this.type ? 'TUTTE LE MISURE' : 'MISURE GIA\' UTILIZZATE'
    },
    filteredSizes : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.cols
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            if(key=='size')
            {
              return String(row[key]).toLowerCase().indexOf(filterKey) > -1
            }
          })
        })
      }
        return items
     },
 
 
  },

    created () 
    {
      
      
      this.getData()
    },

    methods: 
    {

      
    provide: function(col)
    {
     
      col.selected = col.selected == false ? true : false     
      this.sendMessage(col.sizeId)
     
    },

    
    
      
      sendMessage(sizeId) 
      {       

        const sizes = []
        this.cols.forEach(item=>{
          if(item.selected == true)
          {                        
            sizes.push(item)
          }
        })
                
        this.$emit('update',sizes,sizeId)
        
      },  
      setData()
      {
        this.type = !this.type
        this.getData()
      },
      async getData()
      {

        //this.type     = !this.type
        this.spinner  = true
        this.cols     = [] 

        const sp      = {'sp': this.type  ? 'spCompanySizeList':'spSizeList'}
        
        const payload =  this.type ? {'companyId' : this.company.Id}: {}
        const json    = Object.assign(payload, sp)
        
        


        await api.post(json).then(res => {
          if(res.status==200)
            {
              let sizes =  res.data.recordsets[0]
              
              sizes.forEach(item => {
                item.selected = false
                this.cols.push(item)  
            })
            
            this.selection.forEach(item=>{

              this.cols.forEach(col=>{
                if(item.sizeId==col.sizeId)
                {
                  col.selected = true
            
                  
                }
              })    
            })
            
            //console.log(this.cols)
            
           

            }
            else if(res.status==500)
            {
              console.log(res.data)

            } 
            else
            {
              console.log('Network Error.')                  
            } 
        }).catch(err => 
        {
          console.log(err.message)    
        }).finally(() => {
          this.spinner = false
        });
        
      },  

    }
  }
</script>
<style scoped>



p {
  font-family    : 'Roboto Condensed';
  font-size      : 18px;
}

tr:hover {
   cursor        : pointer;
  }

 

 
  h4 {
  font-family : 'Roboto Condensed';
  font-size   : 16px;
}



.card-body-scroll {
  max-height: 400px;   /* scegli tu */
  overflow-y: auto;
  padding: 0.75rem;
}
.table-sm td,
.table-sm th {
  padding: 0.25rem;
}

.form-control-sm {
  height: calc(1.5em + 0.25rem);
  padding: 0.125rem 0.25rem;
}
.card-body-narrow {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}




</style>
